import React from 'react';
import '@cb/apricot/CBBase';
import '@cb/apricot/CBBand';
import '@cb/apricot/CBLogo';
import { IHeaderProps } from '@cb/athena-widgets-types/dist/props';

declare module 'react' {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'cbw-header': IHeaderProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}
/**
 * A header for use across all pages of the site
 */
const GlobalHeader: React.FC = () => {
    return <cbw-header app-id={import.meta.env.VITE_APP_ID} use-search-widget="false" skip-target-id="#satreg-app" />;
};

export default GlobalHeader;
